export const messages = {
  en: {
    componentConditionManage: {
      condition: 'Condition',
      conditionId: 'Condition ID',
      name: 'Name',
      holdpace: 'Holdpace',
      param: 'Param',
      type: 'Type',
      seq: 'Sequence',
      remark: 'Remark',
      text: 'Text',
      date: 'Date',
      fetchError: 'Failed to fetch component conditions',
      requiredName: 'Required, please enter name',
      requiredHoldpace: 'Required, please enter holdpace',
      requiredParam: 'Required, please enter param',
      requiredType: 'Required, please select type',
      requiredSeq: 'Required, please enter sequence',
      optionalRemark: 'Optional, please enter remark',
      requiredComponentId: 'Component ID is required',
      maxComponentId: 'Component ID cannot exceed 30 characters',
      maxName: 'Name cannot exceed 64 characters',
      maxHoldpace: 'Holdpace cannot exceed 64 characters',
      maxParam: 'Param cannot exceed 64 characters',
      maxType: 'Type cannot exceed 12 characters',
      numberSeq: 'Sequence must be a number',
      maxRemark: 'Remark cannot exceed 512 characters',
      requiredConditionId: 'Condition ID is required',
      confirmDelete: 'Are you sure to delete this component condition?'
    }
  },
  zh: {
    componentConditionManage: {
      condition: '条件',
      conditionId: '条件ID',
      name: '名称',
      holdpace: '提示',
      param: '参数',
      type: '类型',
      seq: '序号',
      remark: '描述',
      text: '文本框',
      date: '日期',
      fetchError: '获取组件条件失败',
      requiredName: '必填，请填写名称',
      requiredHoldpace: '必填，请填写提示',
      requiredParam: '必填，请填写参数',
      requiredType: '必填，请选择类型',
      requiredSeq: '必填，请填写序号',
      optionalRemark: '选填，请填写描述',
      requiredComponentId: '组件ID不能为空',
      maxComponentId: '组件ID不能超过30',
      maxName: '名称不能超过64',
      maxHoldpace: '提示不能超过64',
      maxParam: '参数不能超过64',
      maxType: '类型不能超过12',
      numberSeq: '序号必须是数字',
      maxRemark: '描述不能超过512',
requiredConditionId: '條件ID不能為空',
      confirmDelete: '確定刪除該組件條件嗎？'
    }
  },
  'zh-TW': {
    componentConditionManage: {
      condition: '條件',
      conditionId: '條件ID',
      name: '名稱',
      holdpace: '提示',
      param: '參數',
      type: '類型',
      seq: '序號',
      remark: '描述',
      text: '文本框',
      date: '日期',
      fetchError: '獲組件條件失敗',
      requiredName: '必填，請填寫名稱',
      requiredHoldpace: '必填，請填寫提示',
      requiredParam: '必填，請填寫參數',
      requiredType: '必填，請選擇類型',
      requiredSeq: '必填，請填寫序號',
      optionalRemark: '選填，請填寫描述',
      requiredComponentId: '組件ID不能為空',
      maxComponentId: '組件ID不能超過30',
      maxName: '名稱不能超過64',
      maxHoldpace: '提示不能超過64',
      maxParam: '參數不能超過64',
      maxType: '類型不能超過12',
      numberSeq: '序號必須是數字',
      maxRemark: '描述不能超過512',
      requiredConditionId: '條件ID不能為空',
      confirmDelete: '確定刪除該組件條件嗎？'
    }
  }
}